// extracted by mini-css-extract-plugin
export default {"root":"ServerPage_root__igD+z","main":"ServerPage_main__hwosp","hidden":"ServerPage_hidden__dW49s","content":"ServerPage_content__VwKYl"};